<script lang="ts" setup>
import { useSeoTitle } from '@/composables/useSeoTitle'

useSeoTitle('404 - Page not found')
</script>

<template>
  <div class="page-not-found flex w-full items-center justify-center">
    <div class="mx-auto max-w-lg text-center">
      <slot name="title">
        <h1 class="mb-4 text-headings-h2 font-bold">Page Not Found</h1>
      </slot>
      <slot>
        <p class="mb-8">
          The page you're looking for doesn't exist.
          <br />
          Click the button to be return to the home page.
        </p>
      </slot>
      <slot name="actions">
        <VButton to="/">Return to Home</VButton>
      </slot>
    </div>
  </div>
</template>

<style scoped>
.page-not-found {
  height: calc(100vh - 64px);
  padding-bottom: 80px;
}
</style>
